import { generateUUID } from '@/common/util'
import { defineStore } from 'pinia'
import { ref } from 'vue'

import type { ToastPropsType, DialogType } from '@/types/types'

// @TODO: Remover isso daqui
const defaultToastOptions = {
  type: 'info',
  title: 'Info',
  message: 'Empty message.',
  autoClose: true,
  duration: 5
}

interface NotificationsInterface {
  id?: string
  title: string
  message: string
  status: 'sending' | 'processing' | 'success' | 'error'
  haveRead?: boolean
}

export const useNotificationsStore = defineStore('notifications', () => {
  const toasts = ref<ToastPropsType[]>([])
  const dialogs = ref<DialogType[]>([])
  const newDialogs = ref<DialogType[]>([])

  const notifications = ref<NotificationsInterface[]>([])

  const addToast = (toast: ToastPropsType) => {
    const id = generateUUID()
    toasts.value.push({
      id,
      ...Object.assign({ ...defaultToastOptions }, toast)
    })

    return id
  }

  const dismissToast = (id: string) => {
    const index = toasts.value.findIndex((toast) => toast.id === id)
    if (index > -1) toasts.value.splice(index, 1)
  }

  const addDialog = (dialog: DialogType) => {
    dialogs.value.push({
      id: generateUUID(),
      ...dialog
    })
  }

  const setNotification = (notification: NotificationsInterface) => {
    const { title, message, status } = notification
    const index = notifications.value.findIndex((notification) => notification.id === notification.id)

    let id = notification.id || generateUUID()
    const data = {
      id,
      title,
      message,
      status,
      haveRead: false
    }

    if (index > -1) notifications.value.splice(index, 1, data)
    else notifications.value.unshift(data)

    return id
  }

  const markAsRead = (id: string) => {
    const index = notifications.value.findIndex((notification) => notification.id === id)
    if (index > -1) notifications.value[index].haveRead = true
  }

  const dismissDialog = (id: string) => {
    const index = dialogs.value.findIndex((dialog) => dialog.id === id)
    if (index > -1) dialogs.value.splice(index, 1)
  }

  const addNewDialog = (newDialog: DialogType) => {
    newDialogs.value.push({
      id: generateUUID(),
      ...newDialog
    })
  }

  const dismissNewDialog = (id: string) => {
    const index = newDialogs.value.findIndex((dialog) => dialog.id === id)
    if (index > -1) newDialogs.value.splice(index, 1)
  }

  return {
    toasts,
    dialogs,
    notifications,
    newDialogs,
    // Actions
    setNotification,
    markAsRead,
    addToast,
    dismissDialog,
    addDialog,
    dismissToast,
    addNewDialog,
    dismissNewDialog
  }
})
